import { GoogleAnalyticsEntityApiModel } from '../../../api/externalData/models/google-analytics-entity-api.model';


export class GoogleAnalyticsAccountModel {
    id: string;
    name: string;
    profiles: GoogleAnalyticsEntityApiModel[];

    constructor(apiModel: GoogleAnalyticsEntityApiModel, profiles: GoogleAnalyticsEntityApiModel[]) {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.profiles = profiles;
    }
}
